import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { AuthService } from "../../insa-services";

import { appConfig } from "../../../insaweb.config";

type CertLoginSuccess = {
  token: string;
  serialNumber?: string;
  subject?: string;
};
type CertLoginError = { code?: string; message?: string };

@Component({
  templateUrl: "twoFactorCertificate.component.html",
})
export class TwoFactorCertificateComponent implements OnInit {
  username = "";
  errorMessage: string | null = null;
  subtitle = "";
  loginButtonLabel = "";
  private readonly certBridgeBaseUrl = appConfig.certBridgeBaseUrl;

  constructor(
    private readonly http: HttpClient,
    private readonly route: ActivatedRoute,
    private authService: AuthService,
    public router: Router,
  ) {}

  ngOnInit(): void {
    const culture = localStorage.getItem("selected-locale") || (appConfig as any).defaultLocale || "sr-RS";
    this.subtitle = (appConfig as any).messages?.twoFactorCertSubtitle?.[culture]
      || "Priključite USB uređaj sa sertifikatom, zatim kliknite na Prijava.";
    this.loginButtonLabel = (appConfig as any).loginButtonLabel || "Prijava";
  }

  loginWithCertificate(): void {
    this.errorMessage = null;
    this.username = this.getPreAuthTwoFactorUsername() || "";
    if (!this.username) {
      this.errorMessage = "Username is required before certificate login.";
      console.error(this.errorMessage);
      return;
    }
    const url =
      `${this.certBridgeBaseUrl}/api/auth/verify` +
      `?username=${encodeURIComponent(this.username)}`;
    this.http.get<CertLoginSuccess>(url, { withCredentials: true }).subscribe({
      next: (res) => {
        // Branch on why the user is here. Certificate verification proves
        // identity either way; what differs is what we do with that proof.
        if (this.authService.getTwoFactorPurpose() === "reset") {
          this.authService.setResetToken(res.token);
          this.authService.clearPreTwoFactorState();
          this.router.navigate(["/resetPassword"]);
          return;
        }

        this.authService.performAuthenticaton(res.token);
        this.authService.clearPreTwoFactorState();
        this.authService.emitLogedInStatusChange();
        this.router.navigate(["/"]);
      },
      error: (err: HttpErrorResponse) => {
        const { message, code } = this.extractBridgeError(err);
        this.errorMessage = code ? `${message} (${code})` : message;
        console.error("Certificate login failed", err);
      },
    });
  }
  getPreAuthTwoFactorUsername(): string | null {
    return localStorage.getItem("pre2fa_username");
  }
  private extractBridgeError(err: HttpErrorResponse): {
    message: string;
    code?: string;
  } {
    const body = err?.error as CertLoginError | string | null | undefined;
    if (typeof body === "string" && body.trim()) {
      return { message: body };
    }
    if (body && typeof body === "object") {
      const msg =
        typeof body.message === "string" && body.message ? body.message : null;
      const code =
        typeof body.code === "string" && body.code ? body.code : undefined;
      if (msg) return { message: msg };
    }
    return { message: err?.message || "Certificate login failed." };
  }
}


// WEBPACK FOOTER //
// ./app/insa-components/insa-login/twoFactorCertificate.component.ts